/**
 * bootprompt.js locale configuration
 * locale : Greek
 * author : Tolis Emmanouilidis
 */

import { addLocale } from "../bootprompt";

addLocale("el", {
  OK: "Εντάξει",
  CANCEL: "Ακύρωση",
  CONFIRM: "Επιβεβαίωση",
});
